'use strict';
'use client';

import NavbarCollapse from 'react-bootstrap/NavbarCollapse';
import NavbarToggle from 'react-bootstrap/NavbarToggle';
import NavDropdown from 'react-bootstrap/NavDropdown';

const NavDropdownDivider = NavDropdown.Divider;
const NavDropdownItem = NavDropdown.Item;

export { Col, Container, Nav, Navbar, NavbarBrand, NavDropdown, NavItem, NavLink, Row, Stack } from 'react-bootstrap';
export { NavbarCollapse, NavbarToggle, NavDropdownDivider, NavDropdownItem };
